<template>
    <portal to="modals">
        <modal
            :name="name"
            :adaptive="true"
            :scrollable="true"
            :click-to-close="allowClose"
            height="auto"
            width="700px"
            @before-close="beforeClose"
            @before-open="beforeOpen"
        >
            <div class="p-2xl">
                <div
                    v-if="title"
                    class="flex items-center mb-xl"
                >
                    <h1 class="m-0 text-lg font-semibold">{{ title }}</h1>
                </div>

                <div v-if="saveErrors.length">
                    <div v-for="error in saveErrors" class="alert is-error font-regular">
                        <div class="w-full flex flex-col">
                            <div class="flex items-center">
                                <div class="alert-icon">
                                    <font-awesome-icon icon="exclamation" />
                                </div>

                                <span>{{ error.message }}</span>
                            </div>

                            <ul
                                v-if="error.validationErrors"
                                class="list-reset mt-lg block"
                            >
                                <li v-for="validationError in error.validationErrors">
                                    {{ validationError[0] }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <form
                    ref="form"
                    v-loading="loading"
                    autocomplete="off"
                    class="mb-0"
                    @submit.prevent="save"
                >
                    <div class="mb-2xl">
                        <slot />
                    </div>
                    <div class="bg-neutral-lighter py-lg px-xl -mx-2xl -mb-2xl ">
                        <div class="flex flex-col md:flex-row-reverse md:justify-between">
                            <!-- Primary action first to be in correct tab order -->
                            <slot name="primary-action">
                                <button
                                    type="submit"
                                    class="btn btn-lg mb-lg md:mb-0"
                                    :class="primaryButtonClass"
                                >
                                    {{ primaryButtonText }}
                                </button>
                            </slot>
                            <button
                                v-show="allowClose"
                                type="button"
                                class="btn is-ghost btn-lg"
                                @click="hide"
                            >
                                {{ closeButtonText }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </modal>
    </portal>
</template>

<script>
    import FormModal from '../../Atlantis/Modals/FormModal.vue';

    export default {
        extends: FormModal,
    };
</script>
